import { CREATE_VIDEOFLO_SESSION, DELETE_VIDEOFLO_SESSION, VIDEOFLO_SIZE_FULL, VIDEOFLO_SIZE_SMALL  } from "../actions/videoFloActions";

export const videoFloReducer =(InitialState = {}, action)=>{
    switch(action.type){
        case  CREATE_VIDEOFLO_SESSION:{
            return action.payload;
        }
        case VIDEOFLO_SIZE_FULL:{
            return {... InitialState, fullSizeDisplay:true}
        }

        case VIDEOFLO_SIZE_SMALL:{
            return {... InitialState, fullSizeDisplay:false}
        }
        case DELETE_VIDEOFLO_SESSION:{
            return { } 
        }

        default:{
            return InitialState
        }
    }
}